var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFilterIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.754 5.803-6.504 7.84v5.238c-.023.352-.176.598-.457.739q-.4215.246-.879-.036l-2.812-1.968a.866.866 0 0 1-.352-.703v-3.27l-6.504-7.84c-.281-.398-.328-.797-.14-1.195.187-.399.539-.61 1.054-.633h15.68c.492.024.832.234 1.02.633.187.398.152.797-.106 1.195"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFilterIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/filter-icon.239d1b2aaf215cf8d4d2470c77a6bf6f.svg";